// Portfolio data - photos are pulled automatically from
// src/assets/images/portfolio/<category>/. Add more images to those
// folders any time and they'll show up here without touching this file.

function importAll(context) {
	return context.keys().sort().map((key) => context(key));
}

const flatImages = importAll(
	require.context('@/assets/images/portfolio/flat', false, /\.jpg$/)
);
const racecarImages = importAll(
	require.context('@/assets/images/portfolio/racecar', false, /\.jpg$/)
);
const commercialImages = importAll(
	require.context('@/assets/images/portfolio/commercial', false, /\.jpg$/)
);

function buildProjects(images, category) {
	return images.map((img, i) => ({
		id: `${category.toLowerCase()}-${i + 1}`,
		title: `${category} wrap ${i + 1}`,
		category,
		img,
	}));
}

const projects = [
	...buildProjects(flatImages, 'Flat'),
	...buildProjects(racecarImages, 'Racecar'),
	...buildProjects(commercialImages, 'Commercial'),
];

export default projects;
